const REGISTER_ENTRY_STORAGE_KEY = "register_entry_mode";

export type RegisterEntryMode = "standard" | "preRegistration";

export function setRegisterEntryMode(mode: RegisterEntryMode): void {
  if (typeof window === "undefined") return;
  window.sessionStorage.setItem(REGISTER_ENTRY_STORAGE_KEY, mode);
}

export function getRegisterEntryMode(): RegisterEntryMode {
  if (typeof window === "undefined") return "standard";
  const value = window.sessionStorage.getItem(REGISTER_ENTRY_STORAGE_KEY);
  return value === "preRegistration" ? "preRegistration" : "standard";
}

export function isPreRegistrationEntryFlow(): boolean {
  return getRegisterEntryMode() === "preRegistration";
}
